import { QueryResult } from '@apollo/client/react';
import { useTranslation } from 'react-i18next';

import { GiftIcon } from '@treams/treams-icons';
import * as graphql from '@treams/treams-network';
import {
	Card,
	Container,
	Empty,
	InfiniteScroll,
	PAGE_CONTENT_WIDTH,
	Skeleton,
} from '@treams/treams-ui';

import IncomingComplimentCard from './IncomingComplimentCard';

export default function IncomingComplimentsList(props: {
	query: QueryResult<graphql.ViewerGivenComplimentsQuery>;
	userID: string;
}) {
	const { t } = useTranslation();

	const user = props.query.data?.user;

	return (
		<Container mb={3} wide={PAGE_CONTENT_WIDTH}>
			{user ? (
				user.viewerGivenCompliments.edges.length > 0 ? (
					<>
						<Card p={0}>
							{user.viewerGivenCompliments.edges
								.slice()
								.reverse()
								.map(({ node }) => (
									<IncomingComplimentCard
										key={node.id}
										userID={props.userID}
										compliment={node as graphql.Compliment}
									/>
								))}
						</Card>
						<InfiniteScroll query={props.query} path="user.viewerGivenCompliments" reverse>
							<Skeleton.Repeat count={10}>
								<IncomingComplimentCard.Skeleton />
							</Skeleton.Repeat>
						</InfiniteScroll>
					</>
				) : (
					<Skeleton.Empty
						contents={
							<Empty
								icon={<GiftIcon />}
								title={t('compliments.mutual.empty.title')}
								description={t('compliments.mutual.empty.description', {
									name: user.firstName,
								})}
							/>
						}
					>
						<Skeleton.Repeat count={3}>
							<IncomingComplimentCard.Skeleton />
						</Skeleton.Repeat>
					</Skeleton.Empty>
				)
			) : (
				<Skeleton.Repeat count={10}>
					<IncomingComplimentCard.Skeleton />
				</Skeleton.Repeat>
			)}
		</Container>
	);
}
